// controllers/editor_nav_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    continue() {
        document.dispatchEvent(new CustomEvent("ie:continue"))
    }
    back() {
        // your existing back behavior
        window.location = "/party/create"
    }
}